import React from "react"
import cn from "classnames"
import Box, { BoxProps } from "./Box"
import { t } from "../../i18n"

export interface DescriptionBoxProps extends BoxProps {
  i18nText: string;
  i18nTitle: string;
  smallText?: boolean;
}

const DescriptionBox: React.FC<DescriptionBoxProps> = (props: DescriptionBoxProps) => {
  const { i18nText, i18nTitle, smallText, ...boxProps } = props

  const className = cn("mz-description-box", props.className, {
    "mz-description-box--small-text": smallText,
  })

  return (
    <Box {...boxProps} className={className} element="dl">
      <dt className="text-md-bold">{t(i18nTitle)}</dt>
      <dd>{t(i18nText)}</dd>
    </Box>
  )
}

export default DescriptionBox
